import { graphql } from "gatsby"

export const query = graphql`
  fragment LanguagesData on LanguagesYamlConnection {
    edges {
      node {
        general {
          key
          value
        }
        career {
          key
          value
        }
        form {
          key
          value
        }
        navigation {
          key
          value
        }
        parent {
          ... on File {
            name
          }
        }
      }
    }
  }
`

export default function extractMessages(
  languages: Queries.LanguagesDataFragment,
  lang: string,
): Record<string, string> {
  const messages = {}
  if (languages && languages.edges) {
    languages.edges.forEach(languageDefinition => {
      if (languageDefinition.node.parent.name === lang) {
        for (const [key, translations] of Object.entries(
          languageDefinition.node,
        )) {
          if (Array.isArray(translations)) {
            translations.forEach(message => {
              messages[key + "." + message.key] = message.value
            })
          }
        }
      }
    })
  }
  return messages
}
